import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css';
import Home from "./Components/Home/";
import About from "./Components/Pages/About/About";
import Contact from "./Components/Contact";
import Document from "./Components/Pages/Document/Document";
import Health from "./Components/Pages/Health/Health";
import Models from "./Components/Pages/Models/Models";
import Nodes from "./Components/Pages/Nodes/Nodes";
import Scan from "./Components/Pages/Scan/Scan";
import Shop from "./Components/Pages/Shop/Shop";
import Search from "./Components/Search/Search";
import SearchResult from "./Components/SearchResult"

function App() {
  return (
    <BrowserRouter>
    <div>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/search"  element={<Search/>}/>
        <Route path="/about"  element={<About/>}/>
        <Route path="/contact"  element={<Contact/>}/>
        <Route path="/document"  element={<Document/> }/>
        <Route path="/health"  element={<Health/> }/>
        <Route path="/models"  element={<Models/> }/>
        <Route path="/nodes"  element={<Nodes/> }/>
        <Route path="/scan"  element={<Scan/> }/>
        <Route path="/shop"  element={<Shop/> }/>
        <Route path="/result"  element={<SearchResult/> }/>
        
      </Routes>
    </div>
    </BrowserRouter>
  );
}

export default App;
